import "rxjs";
import { fetchReadingList, acceptReadingList, rejectReadingList } from '../api';
import { Observable } from "rxjs/Observable";
import {
    ABORT_REQUEST_READING_LIST, REQUEST_READING_LIST,
    ACCEPT_READING_LIST_REQUEST, REJECT_READING_LIST_REQUEST
} from "../types";
import { fullfiled, throwError } from '../actions/reading-list-actions';

export const readingListEpic = action$ =>
    action$
        .ofType(REQUEST_READING_LIST)
        .map(action => action.payload)
        .mergeMap(
            ({ token, query }) => Observable.fromPromise(fetchReadingList(token, query)).map(fullfiled)
                .takeUntil(action$.ofType(ABORT_REQUEST_READING_LIST))
                .catch(e => Observable.of(throwError(e)))
        );

export const acceptRequestEpic = action$ =>
    action$
        .ofType(ACCEPT_READING_LIST_REQUEST)
        .map(action => action.payload)
        .mergeMap(
            ({ token, id }) => Observable.fromPromise(acceptReadingList(token, id))
                .map(() => [{ type: REQUEST_READING_LIST, payload: token }])
                .takeUntil(action$.ofType(ABORT_REQUEST_READING_LIST))
                .catch(e => Observable.of(throwError(e)))

        );


export const rejectRequestEpic = action$ =>
    action$
        .ofType(REJECT_READING_LIST_REQUEST)
        .map(action => action.payload)
        .mergeMap(
            ({ token, id }) => Observable.fromPromise(rejectReadingList(token, id))
                .map(() => [{ type: REQUEST_READING_LIST, payload: token }])
                .takeUntil(action$.ofType(ABORT_REQUEST_READING_LIST))
                .catch(e => Observable.of(throwError(e)))

        );




// WEBPACK FOOTER //
// ./src/epics/reading-list-epics.js